import module from './index'

let moduleName = 'module->' + module.info.name;
const routes = [
  {
    path: module.info.name,
    name: moduleName,
    component: () => import('./View.vue'),
  }
];

export default routes
